<div class="progress w-100 h-100" [class.loading]="loading" [style.--__percent]="value"></div>
